module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-chalk-4-bf92f3e4700fa93d4df9070e7d1792d9.webp";